import React from 'react';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import 'normalize.css';
import '../../common/css/base-fonts.css';
import './css/page.css';
import Highcharts from 'highcharts';
import { Utils } from '../../common/Utilities';

const e = React.createElement;

export class NewPassiveIncomeRules extends React.Component {
  constructor(props) {
    super(props);
    document.title = 'Small Business Deduction Tax Changes Calculator';
    let self = this;
    let isFrench = Utils.isFrench(props.location.pathname);
    this.state = {
      isFrench: isFrench,
      active_income: 480000,
      passive_investment: 1000000,
      rate_of_return: 6.0,
      province: "Alberta",
      result: '',
      exc_passive_income: 0,
      amount_to_reinvest: 0,
      passive_income: 0,
      avail_sbd: 0,
      province_avail_sbd: 0,
      extra_active_income_tax: 0,
      total_active_income_tax: 0,
      total_active_income_tax_or: 0,
      passive_income_tax: 0,
      net_investment_after_tax_rate_return: 0,
      net_investment_after_tax_rate_return_before: 0,
      small_bus_active_income_tax: 0,
      small_bus_active_income_tax_or: 0,
      exc_active_income_tax: 0,
      exc_active_income_tax_or: 0,
      total_taxes: 0,
      total_taxes_or: 0,
      active_income_tax_rate: 0,
      highest_personal_tax_total_with_surtax: 0,
      sbd_tax_rate: 0,
      business_passive_income_tax_rate: 0,
      province_not_affected_by_passive_income_reduction: false
    };
    this.provinces = [
      ["Alberta", "Alberta"],
      ["British Columbia", "Colombie-Britannique"],
      ["Manitoba", "Manitoba"],
      ["New Brunswick", "Nouveau-Brunswick"],
      ["Newfoundland", "Terre-Neuve"],
      ["Northwest Territories", "Territoires du Nord-Ouest"],
      ["Nova Scotia", "Nouvelle-Écosse"],
      ["Nunavut", "Nunavut"],
      ["Ontario", "Ontario"],
      ["Prince Edward Island", "Île-du-Prince-Édouard"],
      ["Quebec", "Québec"],
      ["Saskatchewan", "Saskatchewan"],
      ["Yukon", "Yukon"]
    ]
    this.xhr = new XMLHttpRequest();
    this.chartRef = React.createRef();
    this.chart = null;
    this.highchart_data = {
      chart: {
        type: 'column'
      },
      title: {
        text: null
      },
      legend: {
        enabled: true,
        itemStyle: {
          fontWeight: 'normal'
        },
        style: {
          'font-family': '"Trebuchet MS", Helvetica, Arial, sans-serif'
        }
      },
      xAxis: {
        categories: [Utils.lang('Old Rules', 'Anciennes règles', isFrench), Utils.lang('New Rules', 'Nouvelles règles', isFrench)],
        style: {
          color: '#000'
        }
      },
      yAxis: {
        title: {
          text: Utils.lang('Corporate Taxes', 'Impôt des sociétés', this.state.isFrench),
          style: {
            'font-family': '"Trebuchet MS", Helvetica, Arial, sans-serif'
          }
        },
        labels: {
          autoRotation: false
        },
        stackLabels: {
          enabled: true,
          formatter: function () {
            if (this.x === 0) {
              return `${self.currency(self.state.total_taxes_or)}`;
            } else {
              return `${self.currency(self.state.total_taxes)}`;
            }
          }
        }
      },
      series: [{
        type: 'column',
        stack: 'test',
        stacking: 'normal',
        name: Utils.lang('Tax on active income at general rate', 'Impôt sur le revenu d’entreprise exploitée activement au taux général', this.state.isFrench) ,
        data: [{y: 0}, {y: 0}],
        color: 'rgb(209, 018, 066)',
        tooltip: {
          headerFormat: '',
          pointFormatter: function () {
            return Utils.lang(
              `${this.formatter(this.y)} of tax on active income<br>at general rate.`,
              `${this.formatter(this.y)} d'impôt sur le revenu<br>d’entreprise exploitée activement<br>au taux général.`,
              this.isFrench
            );
          }
        }
      }, {
        
        type: 'column',
        stack: 'test',
        stacking: 'normal',
        name: Utils.lang('Tax on active income at small business rate', 'Impôt sur le revenu d’entreprise exploitée activement avec DAPE', this.state.isFrench),
        data: [{y: 0}, {y: 0}],
        color: 'rgb(115, 153, 198)',
        tooltip: {
          headerFormat: '',
          pointFormatter: function () {
            return Utils.lang(
              `${this.formatter(this.y)} of tax on active income<br>at small business rate.`, 
              `${this.formatter(this.y)} d'impôt sur le revenu<br>d’entrepriseexploitée activement<br>au taux des petites entreprises.`, 
              this.isFrench
            );
          }
        }
      }, {  
        type: 'column',
        stack: 'test',
        stacking: 'normal',
        name: Utils.lang('Tax on passive income', 'Impôt sur le revenu passif', this.state.isFrench),
        data: [{y: 0}, {y: 0}],
        color: 'rgb(069, 085, 096)',
        tooltip: {
          headerFormat: '',
          pointFormatter: function () {
            return Utils.lang(
              `${this.formatter(this.y)} of tax on passive income.`,
              `${this.formatter(this.y)} d'impôt sur le revenu passif.`,
              this.isFrench
            );
          }
        }
      }]
    }
    this.number_mask = createNumberMask({
      prefix: (isFrench) ? '' : '$',
      suffix: (isFrench) ? ' $' : '',
      allowDecimal: true,
      decimalLimit: 2,
      includeThousandsSeparator: true,
      thousandsSeparatorSymbol: (isFrench) ? ' ' : ','
    });
    this.number_percentage_mask = createNumberMask({
      prefix: '',
      suffix: Utils.lang('%', ' %', isFrench),
      allowDecimal: true,
      decimalLimit: 10,
      includeThousandsSeparator: true,
      thousandsSeparatorSymbol: (isFrench) ? ' ' : ','
    });
    this.handleChange = this.handleChange.bind(this);
    this.handleProvinceChange = this.handleProvinceChange.bind(this);
  }

  handleChange(event) {
    let val = event.target.value.replace(/[^\d.-]/g, '');
    this.xhr.abort();
    this.setState({ [event.target.name]: val }, function () {
      this.fetchResult();
    });
  }

  handleProvinceChange(event) {
    this.setState({ province: event.target.value }, function () {
      this.fetchResult();
    });
  }

  fetchResult() {
    var params = "?";
    params += "active_income=" + this.state.active_income;
    params += "&passive_investment=" + this.state.passive_investment;
    params += "&rate_of_return=" + this.state.rate_of_return;
    params += "&province=" + this.state.province;
    this.xhr.open("GET", "/api/small-business-deduction/deduction" + params, true);
    this.xhr.onreadystatechange = function () {
      if (this.xhr.readyState === 4 && this.xhr.status === 200) {
        var result = JSON.parse(this.xhr.responseText);
        this.setState({
          passive_income: result.passive_income,
          exc_passive_income: result.exc_passive_income,
          extra_active_income_tax: result.extra_active_income_tax,
          amount_to_reinvest: result.amount_to_reinvest,
          avail_sbd: result.avail_sbd,
          province_avail_sbd: result.province_avail_sbd,
          total_active_income_tax: result.total_active_income_tax,
          total_active_income_tax_or: result.total_active_income_tax_or,
          passive_income_tax: result.passive_income_tax,
          small_bus_active_income_tax: result.small_bus_active_income_tax,
          small_bus_active_income_tax_or: result.small_bus_active_income_tax_or,
          exc_active_income_tax: result.exc_active_income_tax,
          exc_active_income_tax_or: result.exc_active_income_tax_or,
          total_taxes: result.total_taxes,
          total_taxes_or: result.total_taxes_or,
          active_income_tax_rate: result.active_income_tax_rate,
          highest_personal_tax_total_with_surtax: result.highest_personal_tax_total_with_surtax,
          sbd_tax_rate: result.sbd_tax_rate,
          business_passive_income_tax_rate: result.business_passive_income_tax_rate,
          amount_sbd_decreased_by: result.amount_sbd_decreased_by,
          province_not_affected_by_passive_income_reduction: !!result.province_not_affected_by_passive_income_reduction
        }, function () {
          this.updateChart();
        }.bind(this));
      }
      else {
        this.setState({ result: "" });
      }
    }.bind(this);
    this.xhr.send();
  }

  updateChart() {
    this.chart.series[0].setData([
      {y: this.state.exc_active_income_tax_or, formatter: this.currency, isFrench: this.state.isFrench},
      {y: this.state.exc_active_income_tax, formatter: this.currency, isFrench: this.state.isFrench}
    ], false);
    this.chart.series[1].setData([
      {y: this.state.small_bus_active_income_tax_or, formatter: this.currency, isFrench: this.state.isFrench},
      {y: this.state.small_bus_active_income_tax, formatter: this.currency, isFrench: this.state.isFrench}
    ], false);
    this.chart.series[2].setData([
      {y: this.state.passive_income_tax, formatter: this.currency, isFrench: this.state.isFrench},
      {y: this.state.passive_income_tax, formatter: this.currency, isFrench: this.state.isFrench}
    ], true);
  }

  buildProvinces() {
    var options = [];
    for (var i = 0; i < this.provinces.length; i++) {
      const txt = Utils.lang(this.provinces[i][0], this.provinces[i][1], this.state.isFrench);
      options.push(e('option', { key: i, value: this.provinces[i][0] }, txt));
    }
    return options;
  }

  currency(number) {
    let locale = Utils.lang('en-CA', 'fr-CA', this.state.isFrench);
    var formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'CAD',
      minimumFractionDigits: 2
    });
    return formatter.format(number).replace(/\D00$/, '');
  }

  percent(number) {
    return number + '%';
  }

  componentDidMount() {
    this.fetchResult();
    this.chart = Highcharts.chart(this.chartRef.current, this.highchart_data);
  }

  render() {
    let introduction1 = <p className="section-introduction">
      {
        Utils.lang(`For Canadian controlled private corporations earning active business income, the small business deduction is available which provides a lower rate of tax on the first $500,000 of active business income earned in the year. The provinces also have a small business deduction equal to the federal amount (except for Saskatchewan whose limit is $600,000).  This low rate of tax does not apply to passive investment income (interest, dividends and realized capital gains).`,
        `Les sociétés privées sous contrôle canadien qui gagnent un revenu d'entreprise active peuvent bénéficier d'une déduction pour petites entreprises qui leur permet de bénéficier d'un taux d'imposition inférieur sur la première tranche de 500 000 dollars de revenu d'entreprise active gagné au cours de l'année. Les provinces disposent également d'une déduction pour petites entreprises égale au montant fédéral (à l'exception de la Saskatchewan dont le plafond est de 600 000 $).  Ce faible taux d'imposition ne s'applique pas aux revenus d'investissements passifs (intérêts, dividendes et gains en capital réalisés).`,
        this.state.isFrench)
      }
    </p>
    let introduction2 = <p className="section-introduction">
      {
        Utils.lang(`The passive investment rules could reduce the amount of the small business deduction available for active income earned in a corporation. The small business deduction is reduced when certain thresholds are met.  The federal and provincial small business deductions are reduced $5 for every $1 of passive income that the corporation (and associated corporations) earned in the prior year  over $50,000 and are completely eliminated if the corporation earns over $150,000. Please note that Ontario and New Brunswick did not mirror the federal rules so for these provinces there is only the federal reduction and no corresponding reduction to the provincial small business deduction.`,
        `Les règles relatives aux investissements passifs pourraient réduire le montant de la déduction accordée aux petites entreprises pour les revenus actifs gagnés dans une société. La déduction pour petites entreprises est réduite lorsque certains seuils sont atteints.  Les déductions fédérale et provinciale pour les petites entreprises sont réduites de 5 $ pour chaque dollar de revenu passif que la société (et les sociétés associées) a gagné au cours de l'année précédente au-delà de 50 000 $ et sont complètement éliminées si la société gagne plus de 150 000 $. Veuillez noter que l'Ontario et le Nouveau-Brunswick n'ont pas adopté les règles fédérales, de sorte que pour ces provinces, il n'y a que la réduction fédérale et aucune réduction provinciale correspondante pour les petites entreprises.`,
        this.state.isFrench)
      }
    </p>
    let introduction3 = <p className="section-introduction">
    {
      Utils.lang(`Find out how your corporation is affected:`,
      `Voyez l’incidence de ces nouvelles règles sur votre société :`,
      this.state.isFrench)
    }
  </p>
    let disclaimer = <div className="disclaimer">
      <h4>{ Utils.lang('Disclaimer', 'Déclaration', this.state.isFrench) }</h4>
      <p>
        {
          Utils.lang(
            `This calculator is for illustrative purposes only. Readers should seek independent legal, tax, financial and accounting advice with regard to the views expressed on this site. Any numbers illustrated are provided as example and are to be used as estimates only.`,
            `Ce calculateur n’est utilisé qu’à des fins d’illustration. Le lecteur devrait demander l’avis d’un conseiller juridique, fiscal, comptable ou financier indépendant au sujet des opinions exprimées sur ce site. Les chiffres illustrés ne sont donnés qu’à titre d’exemple et ne doivent être utilisés qu’à des fins d’estimation.`,
            this.state.isFrench
          )
        }
      </p>
    </div>
    let assumptions = <div className="assumptions">
      <h4>{ Utils.lang('Assumptions', 'Hypothèses', this.state.isFrench) }</h4>
      <p>
        {
          Utils.lang(
            `Tax rates used: ${this.state.sbd_tax_rate}% for small business rate, ${this.state.active_income_tax_rate}% for general rate, and ${this.state.business_passive_income_tax_rate}% for passive income rate.`,
            `Les taux d’imposition : Taux de petite entreprise de ${this.state.sbd_tax_rate} %, taux général de ${this.state.active_income_tax_rate} % et taux sur le revenu passif de ${this.state.business_passive_income_tax_rate} %.`,
            this.state.isFrench
          )
        }
      </p>
      <p>
        {
          Utils.lang(
            `* The rate of return is based on the taxable income earned in your corporation.`,
            `* Le taux de rendement est fondé sur le revenu imposable généré à l’intérieur de votre société.`,
            this.state.isFrench
          )
        }
      </p>
      <p>
        {
          Utils.lang(
            `** Small business deduction limits available after the reduction are ${this.currency(this.state.avail_sbd)} federal and ${this.currency(this.state.province_avail_sbd)} provincial.`,
            `** Après la réduction, le plafond de la déduction accordée aux petites entreprises est de ${this.currency(this.state.avail_sbd)} au niveau fédéral et de ${this.currency(this.state.province_avail_sbd)} au niveau provincial.`,
            this.state.isFrench
          )
        }
      </p>
    </div>
    let impacted_results_summary = <div className="summary">
      {
        Utils.lang(
          <p>Your corporation's passive income is {this.currency(this.state.passive_income)}. There is an excess passive income of {this.currency(this.state.exc_passive_income)} beyond the $50,000 limit; this reduces your {(this.state.province_not_affected_by_passive_income_reduction) ? 'federal ' : ''}small business deduction by {this.currency(this.state.amount_sbd_decreased_by)}**. As a result, the tax paid on active income goes from {this.currency(this.state.total_active_income_tax_or)} before the change to {this.currency(this.state.total_active_income_tax)} after the change. The additional tax your corporation will pay on active income is <strong>{this.currency(this.state.extra_active_income_tax)}</strong>.</p>,
          <p>Le revenu passif de votre société s’élève à {this.currency(this.state.passive_income)}. Ce montant dépasse de {this.currency(this.state.exc_passive_income)} le seuil de 50 000 $; la déduction accordée aux petites entreprises est donc réduite de {this.currency(this.state.amount_sbd_decreased_by)}**. Par conséquent, l’impôt payé sur le revenu d’entreprise exploitée activement passe de {this.currency(this.state.total_active_income_tax_or)} avant le changement, à {this.currency(this.state.total_active_income_tax)} après le changement. Votre société devra donc payer <strong>{this.currency(this.state.extra_active_income_tax)}</strong> de plus en impôt sur ce revenu.</p>,
          this.state.isFrench
        )
      }
      {
        Utils.lang(
          <p>Planning can be completed to maximize the small business deduction by  reducing the corporation’s passive investments so that the passive income earned does not exceed the $50,000 limit (it is the prior year’s passive income that will determine the reduction to the small business limit) &mdash; <em>for your corporation that would mean reallocating {this.currency(this.state.amount_to_reinvest)} of passive assets based on your assumed rate of return</em>. This can be accomplished by reviewing the investment mix of the corporation’s assets and repaying shareholder loans, distributing assets to shareholders by way of capital or taxable dividends, or purchasing permanent life insurance since the growth in the policy is not included in the passive investment calculation (unless the funds are withdrawn).</p>,
          <p>Il est possible de planifier en vue de maximiser la déduction accordée aux petites entreprises en réduisant les placements passifs de la société de façon que le revenu de ces placements ne dépasse pas le seuil de 50 000 $ (c’est le revenu de placement passif de l’année précédente qui détermine la réduction de la déduction accordée aux petites entreprises) &mdash; <em>dans le cas de votre société, cela nécessite la réaffectation de {this.currency(this.state.amount_to_reinvest)} en actifs hors exploitation selon votre taux de rendement prévu</em>. Cela peut se faire en revoyant la composition des investissements de la société et en remboursant les prêts aux actionnaires, en distribuant des actifs aux actionnaires sous forme de capital ou de dividendes imposables, ou en souscrivant une assurance vie permanente puisque la croissance de la police n'est pas incluse dans le calcul de l'investissement passif (à moins que les fonds ne soient retirés).</p>,
          this.state.isFrench
        )
      }
      {
        Utils.lang(
          <p>Note that there is still a deferral advantage to having income taxed in the corporation even if the small business deduction is lost, since the highest marginal personal rate is {this.state.highest_personal_tax_total_with_surtax}% in {this.state.province} compared to the {this.state.active_income_tax_rate}% active business income general tax rate.</p>,
          <p>Veuillez noter qu’il demeure avantageux que le revenu soit imposé dans les mains de la société, même si cela entraîne la perte de la déduction accordée aux petites entreprises, puisque le taux marginal d’imposition des particuliers le plus élevé en {this.state.province} est de {this.state.highest_personal_tax_total_with_surtax} %, contre un taux général de {this.state.active_income_tax_rate} % sur les revenus d’entreprise exploitée activement.</p>,
          this.state.isFrench
        )
      }
    </div>
    let not_impacted_below_limit_results_summary = <div className="summary">
      <p>{
        Utils.lang(
          `The total passive income is ${this.currency(this.state.passive_income)}. This is ${(this.state.passive_income === 50000) ? 'at' : 'below'} the $50,000 limit, therefore there is no change to your small business deduction. As a result there is no additional new tax paid.`,
          `Le revenu passif de votre société s’élève à ${this.currency(this.state.passive_income)}. Puisque ce montant est ${(this.state.passive_income === 50000) ? 'à la limite du seuil' : 'sous la limite'} de 50 000 $, la déduction de votre petite entreprise ne change pas. Vous n’avez donc pas d’impôt additionnel à payer.`,
          this.state.isFrench
        )
      }</p>
    </div>
    let not_impacted_above_limit_results_summary = <div className="summary">
      <p>{
        Utils.lang(
          `There is no change to your small business deduction. As a result there is no additional new tax paid.`,
          `La déduction de votre petite entreprise ne change pas. Vous n’avez donc pas d’impôt additionnel à payer.`,
          this.state.isFrench
        )
      }</p>
    </div>
    let summary = impacted_results_summary
    if (this.state.passive_income <= 50000)
      summary = not_impacted_below_limit_results_summary;
    if (this.state.total_taxes === this.state.total_taxes_or)
      summary = not_impacted_above_limit_results_summary;
    return (
      <div>
        <div className='container'>
          <section className='calculator'>
            <div className='section-contents'>
              {introduction1}
              {introduction2}
              {introduction3}
              <div className="illustration">
                <div className='input'>
                  <div className='background'>
                    <label>
                      <span>{ Utils.lang('Active income', 'Revenu d’entreprise exploitée activement', this.state.isFrench) }</span>
                      <MaskedInput mask={this.number_mask} name='active_income' autoComplete='off' onChange={this.handleChange} value={this.state.active_income} type='text' />
                    </label>
                    <label>
                      <span>{ Utils.lang('Passive investment', 'Placement passif', this.state.isFrench) }</span>
                      <MaskedInput mask={this.number_mask} name='passive_investment' autoComplete='off' onChange={this.handleChange} value={this.state.passive_investment} type='text' />
                    </label>
                    <label>
                      <span>{ Utils.lang('Rate of return*', 'Taux de rendement*', this.state.isFrench) }</span>
                      <MaskedInput mask={this.number_percentage_mask} name='rate_of_return' autoComplete='off' onChange={this.handleChange} value={this.state.rate_of_return} type='text' />
                    </label>
                    <label>
                      <span>{ Utils.lang('Province', 'Province', this.state.isFrench) }</span>
                      <select name='province' onChange={this.handleProvinceChange}>{this.buildProvinces()}</select>
                    </label>
                    <div className='result'>{ Utils.lang('Increase in tax:', 'Augmentation d’impôt :', this.state.isFrench) } <strong>{this.currency(this.state.extra_active_income_tax)}</strong></div>
                  </div>
                </div>
                <div ref={this.chartRef} className='chart ct-chart ct-perfect-fourth'></div>
              </div>
              <h2 className='sub-section-heading'>{ Utils.lang('Results summary', 'Sommaire des résultats', this.state.isFrench) }</h2>
              {summary}
              <p>
                {
                  Utils.lang(
                    `There are many complexities to these rules, and every situation is unique. Your best option is to speak with your professional advisors to help determine the best solution for you and your corporation.`,
                    `Ces règles comportent de nombreuses complexités et chaque situation est unique. Il est toujours recommandé de vous entretenir avec vos conseillers professionnels, qui vous aideront à choisir la meilleure solution pour vous et votre société.`,
                    this.state.isFrench)
                }
              </p>
              {assumptions}
              {disclaimer}
            </div>
          </section>
        </div>
      </div>
    );
  }

}
